import { Pipe, PipeTransform } from '@angular/core';
import { getAccessibleBadgeStyles } from 'src/app/utils/utils.function';

@Pipe({
    name: 'statusTextColor',
    standalone: false
})
export class StatusTextColorPipe implements PipeTransform {
  transform(bgColor: string | undefined | null): string {
    return getAccessibleBadgeStyles(bgColor || '#66bb6a').color;
  }
}
